import React, { useState } from "react";

export default function ShareButton({
  path = window.location.pathname + window.location.search,
}) {
  const [state, setState] = useState("");
  const url = new URL(path, window.location.origin).href;
  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setState("Link copied");
    } catch {
      setState("Copy this link");
    }
  }
  return (
    <div className="report-share">
      <p className="report-note">Share this link. Recipients need to log in to view the report.</p>
      <button type="button" onClick={copy}>
        <i className="fa fa-link" aria-hidden="true" /> Share report
      </button>
      {state && (
        <div role="status">
          <span>{state}</span>
          {state === "Copy this link" && (
            <input
              aria-label="Shareable report link"
              readOnly
              value={url}
              onFocus={(event) => event.target.select()}
            />
          )}
        </div>
      )}
    </div>
  );
}
